import { render, staticRenderFns } from "./TypeTasks.vue?vue&type=template&id=85cf8402&"
import script from "./TypeTasks.vue?vue&type=script&lang=js&"
export * from "./TypeTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports